import {
  Button,
  Card,
  Col,
  DeleteButton,
  EditButton,
  Form,
  Icons,
  Input,
  List,
  Row,
  ShowButton,
  Space,
  Table,
  TextField,
  useTable,
} from "@pankod/refine-antd";
import {
  HttpError,
  IResourceComponentsProps,
  LogicalFilter,
} from "@pankod/refine-core";
import { IPartner, IPartnerFilter } from "interfaces/partner";
import { PartnerSellersModal } from "components/modals/mdl_partner_sellers";
import { FC, useState } from "react";
import { formatPhone } from "utils/formaters";

export const PartnerList: FC<IResourceComponentsProps> = () => {
  const [activePartner, setActivePartner] = useState<IPartner | null>(null);

  const { tableProps, searchFormProps, tableQueryResult } = useTable<
    IPartner,
    HttpError,
    IPartnerFilter
  >({
    initialCurrent: 1,
    initialPageSize: 10,
    hasPagination: true,
    onSearch: (values) => {
      const filtros: LogicalFilter[] = Object.entries(values).map(
        ([key, value]) => ({
          field: key,
          operator: "eq",
          value,
        })
      );

      return filtros;
    },
  });

  const handleCleanFilters = () => {
    searchFormProps.form?.resetFields();
  };

  const handleOpenSellers = (partner: IPartner) => {
    setActivePartner(partner);
  };

  const handleCloseSellers = () => {
    setActivePartner(null);
  };

  return (
    <List
      title="Parceiros"
      createButtonProps={{ children: "Incluir", type: "primary" }}
    >
      <Card title="Filtrar">
        <Form {...searchFormProps} layout="vertical">
          <Row gutter={[16, 16]} style={{ width: "100%" }}>
            <Col xs={24} sm={12}>
              <Form.Item name="partner_name" label="Nome">
                <Input placeholder="Nome" />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item name="partner_code" label="Código do Parceiro">
                <Input placeholder="Código do Parceiro" />
              </Form.Item>
            </Col>

            <Col xs={24} style={{ textAlign: "right", marginTop: 8 }}>
              <Space>
                <Button
                  type="default"
                  icon={<Icons.ClearOutlined />}
                  onClick={handleCleanFilters}
                >
                  Limpar
                </Button>
                <Button
                  type="primary"
                  icon={<Icons.SearchOutlined />}
                  htmlType="submit"
                >
                  Buscar
                </Button>
              </Space>
            </Col>
          </Row>
        </Form>
      </Card>

      <Table
        {...tableProps}
        rowKey="_id"
        loading={tableQueryResult.isLoading}
        pagination={{
          ...tableProps.pagination,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} de ${total} registros`,
        }}
      >
        <Table.Column
          dataIndex="partner_name"
          title="Nome"
          render={(value) => <TextField value={value || "-"} />}
        />

        <Table.Column
          dataIndex="partner_code"
          title="Código do Parceiro"
          render={(value) => <TextField value={value || "-"} />}
        />

        <Table.Column
          dataIndex="partner_phone"
          title="Telefone"
          render={(value) => (
            <TextField
              style={{ whiteSpace: "nowrap" }}
              value={value ? formatPhone(value) : "-"}
            />
          )}
        />

        <Table.Column
          title="Ações"
          render={(_, record: any) => (
            <Space>
              <Button
                size="small"
                icon={<Icons.DollarCircleOutlined />}
                onClick={() => handleOpenSellers(record)}
              >
                Vendedores
              </Button>
              <EditButton hideText size="small" recordItemId={record._id} />
              <ShowButton hideText size="small" recordItemId={record._id} />
              <DeleteButton
                hideText
                size="small"
                recordItemId={record._id}
                confirmTitle={`Tem certeza que deseja remover o parceiro${
                  record?.partner_default ? " padrão atual" : ""
                }?`}
              />
            </Space>
          )}
        />
      </Table>

      <PartnerSellersModal
        isOpen={Boolean(activePartner)}
        partner={activePartner}
        onClose={handleCloseSellers}
      />
    </List>
  );
};
